var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPip = function SvgPip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 20"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "pip_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1112 0v251H0V0h1112Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "pip_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.7 9.9a1.2 1.2 0 0 1 1.2 1.2v7.6a1.2 1.2 0 0 1-1.2 1.2H11.505a1.2 1.2 0 0 1-1.2-1.2v-7.6a1.2 1.2 0 0 1 1.2-1.2H24.7ZM20.434 0a2.1 2.1 0 0 1 2.095 1.95l.005.15v5.4a.9.9 0 0 1-1.793.113l-.007-.113V2.1a.3.3 0 0 0-.231-.292l-.069-.008H2.1a.3.3 0 0 0-.292.231L1.8 2.1v10.662a.3.3 0 0 0 .231.293l.069.008h5.398a.9.9 0 0 1 .113 1.792l-.113.008H2.1a2.1 2.1 0 0 1-2.095-1.95L0 12.762V2.1A2.1 2.1 0 0 1 1.95.005L2.1 0h18.334ZM8.558 3.325a.6.6 0 0 1 .592.503l.008.097v5.277l-.789.002a.604.604 0 0 1-.144 0L3.66 9.202a.6.6 0 0 1-.098-1.192l.098-.008 3.158-.001L3.24 4.493a.6.6 0 0 1 .757-.926l.084.069 3.877 3.802V3.925a.6.6 0 0 1 .503-.592l.097-.008Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#pip_svg__a)",
    transform: "translate(-437 -22)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#pip_svg__b)",
    transform: "translate(437 22)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h25.9v19.9H0V0z"
  })))));
};

export default SvgPip;